import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { filtersDTO, NotZootResponseDTO } from "./dataService/dto"
import { PromiseStatuses } from "../../../../utils"
import { NewNotLivestockService } from "./dataService/service"

interface NotificationLivestockState {
    onEdit: boolean
    getAllZootRows?: NotZootResponseDTO
    getAllZootRowsStatus: PromiseStatuses
    filtersLivestock: filtersDTO
}

const initialState: NotificationLivestockState = {
    onEdit: false,
    getAllZootRowsStatus: 'idle',
    filtersLivestock: {
        page: 0,
        itemsPerPage: 0
    }
}

export const GetAllZootRows = createAsyncThunk(
    'Not/GetAllZootRows',
    async (filters: filtersDTO, thunkApi): Promise<NotZootResponseDTO> => {
        const NotLivestockService = NewNotLivestockService()
        return NotLivestockService.GetAllZootByNot(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)


const NotificationLivestockSlice = createSlice({
    name: 'notificationLivestock/slice',
    initialState,
    reducers: {
        setOnEdit: (state, action) => {
            state.onEdit = action.payload
        },
        resetGetAllStatus: (state) => {
            state.getAllZootRowsStatus = 'idle'
        },
        resetFilters: (state) => {
            state.filtersLivestock = {
                page: 0,
                itemsPerPage: 0
            }
        }
    },
    extraReducers(builder) {
        builder

            .addCase(GetAllZootRows.pending, (state) => {
                state.getAllZootRowsStatus = 'loading'
            })
            .addCase(GetAllZootRows.fulfilled, (state, action) => {
                state.getAllZootRowsStatus = 'successfully'
                state.getAllZootRows = action.payload
            })
            .addCase(GetAllZootRows.rejected, (state, action) => {
                state.getAllZootRowsStatus = 'failed'
            })

    }
})

export const {
    setOnEdit,
    resetGetAllStatus
} = NotificationLivestockSlice.actions

export default NotificationLivestockSlice.reducer